import css from 'styled-jsx/css';

export default css`
  .AmpImg {
    display: grid;
    grid-template-areas:
      'image'
      'caption';
    grid-template-rows: auto max-content;
  }

  .AmpImg amp-img,
  .AmpImg__link {
    grid-area: image;
  }

  .AmpImg :global(.ImageCaption) {
    grid-area: caption;
    margin-top: 0.25rem;
  }

  .AmpImg__pinterest {
    grid-area: image;
    align-self: end;
    justify-self: end;
    margin: 0 1rem 1rem 0;
  }

  .AmpImg__info {
    display: flex;
    justify-content: space-between;
    margin-top: 0.25rem;
  }

  .PrismEntryButton--text {
    display: flex;
  }
`;
